import type { PropsWithChildren } from 'react';
import styled from 'styled-components';

import { Suspense } from '@sorare/core/src/atoms/Suspense';
import { Horizontal, SBHorizontal } from '@sorare/core/src/atoms/layout/flex';
import { ProSetToggle } from '@sorare/core/src/components/navigation/AppNavigation/ProSetToggle/index.tsx';
import { UserCurrencies } from '@sorare/core/src/components/navigation/AppNavigation/UserCurrencies';
import { UserNav } from '@sorare/core/src/components/navigation/UserNav';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useIsLaptop } from '@sorare/core/src/hooks/device/useIsLaptop.ts';
import { lazy } from '@sorare/core/src/lib/retry';

import { SearchBarHeaderButton } from '#src/components/navigation/NewAppHeader/WebAppHeader/SearchBarHeaderButton/index.tsx';

const Notifications = lazy(
  async () => import('#src/components/notification/Notifications/index.tsx'),
  'Notifications'
);

const StyledSBHorizontal = styled(SBHorizontal)`
  display: grid;
  grid-template-columns: 1fr max-content 1fr;
`;

const ChildrenDesktopWrapper = styled(Horizontal).attrs({ gap: 0 })`
  justify-content: flex-end;
`;

export const BoardWebAppHeader = ({ children }: PropsWithChildren) => {
  const { sport } = useSportContext();
  const isLaptopAndAbove = useIsLaptop();

  return (
    <StyledSBHorizontal>
      <Horizontal>
        <UserNav sport={sport} size={isLaptopAndAbove ? 'medium' : 'small'} />
        <UserCurrencies variant="vertical" />
      </Horizontal>
      <ProSetToggle />
      <ChildrenDesktopWrapper>
        <Suspense fallback={null}>
          <Notifications />
        </Suspense>
        <SearchBarHeaderButton />
        {children}
      </ChildrenDesktopWrapper>
    </StyledSBHorizontal>
  );
};
